import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { GenericPopper } from "../../../components";
import { IconButton } from "../../../components/IconButton";
import { showSubscriptionModal } from "../../../components";
import { DropdownItem } from "../../../panels/list/Components/DropdownItem";
import { accountFeatures, getCenter, useSSelector } from "../../../util";

type Props = {
  cropfield?: any;
  location?: any;
  className?: string;
};

export const MapMenu = ({ cropfield, location, className }: Props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const isPro = useSSelector((s) => accountFeatures(s.activeUser.account).pro);

  const openGoogleMap = useCallback(() => {
    if (!isPro) {
      showSubscriptionModal(dispatch, undefined, "navigate");
      return;
    }
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${
        location || getCenter(cropfield, null, 5).reverse().join(",")
      }&travelmode=driving`
    );
  }, [cropfield, dispatch, isPro, location]);

  const openAppleMap = useCallback(() => {
    if (!isPro) {
      showSubscriptionModal(dispatch, undefined, "navigate");
      return;
    }
    window.open(
      `https://maps.apple.com/?daddr=${
        location || getCenter(cropfield, null, 5).reverse().join(",")
      }`
    );
  }, [cropfield, dispatch, isPro, location]);

  return (
    <GenericPopper
      className={className}
      content={
        <>
          <DropdownItem icon={"icon fab fa-google"} title="Google Maps" onClick={openGoogleMap} />
          <DropdownItem icon={"icon fab fa-apple"} title="Apple Maps" onClick={openAppleMap} />
        </>
      }
      open={open}
      placement="bottom"
      onClose={() => {
        setOpen(false);
      }}
    >
      <div>
        <IconButton
          icon="map-signs"
          onClick={(e) => {
            setOpen(!open);
            e.preventDefault();
          }}
        />
      </div>
    </GenericPopper>
  );
};
